var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown-circle"},[_c('app-cirlce',{attrs:{"percent":_vm.percent,"stroke-width":2,"stroke-color":"#57aef1","trail-color":"#fff"}},[_c('p',{staticClass:"countdown-time"},[_vm._v(_vm._s(_vm.time))]),_c('p',{staticClass:"countdown-text"},[_vm._v("剩余时间")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }